import { stringify } from "qs";

import consumerApi from "@/api/services/consumer-api";
import { Coordinates } from "@/custom-types/Coordinates";
import { Query } from "@/custom-types/Query";
import { ShopResponse } from "@/custom-types/Shop";
import logError from "@/utils/logError";

const getSearchShopResults = async (
  query: Query,
  coordinates: Coordinates,
  maxDistance: number,
  countryCode?: string,
  showSimilarStrains?: boolean,
) => {
  const route = "/api/search/v1/shop";

  const boostParams = showSimilarStrains
    ? { boost: "similar_dispensaries" }
    : {};

  const body = stringify(
    {
      ...boostParams,
      ...query,
      ...coordinates,
      "filter[max_distance]": maxDistance || 30,
      take: 20,
    },
    {
      arrayFormat: "brackets",
      encodeValuesOnly: true,
    },
  );

  try {
    const { data } = await consumerApi.get<ShopResponse>(`${route}?${body}`, {
      headers: {
        "x-country-code": countryCode || "US",
      },
    });

    const {
      hits: { strain, brand, dispensary },
      metadata: { availableFilters, totalCount },
    } = data;

    const mappedFilters = availableFilters.map((filter) => ({
      ...filter,
      values: filter.values.map((value) => value.value),
    }));

    return {
      availableFilters: mappedFilters,
      brand: brand || [],
      dispensary: dispensary || [],
      strain: strain || [],
      totalCount,
    };
  } catch (e) {
    logError(e.message, {
      functionName: "getSearchShopResults",
      service: "consumer",
      statusCode: e.statusCode,
    });

    return {
      availableFilters: [],
      brand: [],
      dispensary: [],
      strain: [],
      totalCount: 0,
    };
  }
};

export default getSearchShopResults;
